import { useState } from 'react'

import { Text } from '@hhgtech/hhg-components'

import { StyledRadioImageGroup, StyledRadioImageItem } from './index.styled'

export type Props = {
  options: Array<{
    value: string
    label?: string
    image?: string
    imageActive?: string
  }>
  value?: string
  className?: string
  isDisabled?: boolean
  size?: 'small' | 'large'
  direction?: 'vertical' | 'horizontal'
  onChange?: (v: string) => void
}

const RadioImageGroupForTool = ({
  value,
  options,
  className,
  direction = 'horizontal',
  onChange,
  isDisabled,
}: Props) => {
  const [check, setCheck] = useState(value)

  const handleOnChange = (v: string) => {
    if (isDisabled) return
    setCheck(v)
    onChange && onChange(v)
  }

  return (
    <StyledRadioImageGroup className={className} data-direction={direction}>
      {options.map((option, index) => (
        <StyledRadioImageItem
          data-selected={(value || check) === option.value}
          data-disabled={isDisabled}
          key={`health-tool${index}`}
          onClick={() => {
            handleOnChange(option.value)
          }}
        >
          <div>
            <img
              src={
                (value || check) === option.value
                  ? option.imageActive
                  : option.image
              }
              className="gender-image"
              alt=""
              width={23}
              height={36}
              loading="lazy"
            />

            {option.label && (
              <Text
                type="bold"
                className="radio-group-item-heading"
                size="label1"
              >
                {option.label}
              </Text>
            )}
          </div>
        </StyledRadioImageItem>
      ))}
    </StyledRadioImageGroup>
  )
}

export { RadioImageGroupForTool }
